/**
 * APA References list renderer.
 *
 * Mirrors the references block in _build_combined_html() in
 * backend/services/dossier/eu_combined_renderer/__init__.py (line ~307).
 *
 * Each reference string is rendered as a hanging-indent list item (the same
 * visual style as `.apa-ref` in the PDF CSS: padding-left 24pt + text-indent
 * -24pt). In Tailwind we approximate this with pl-6 + -indent-6.
 *
 * When the list is empty, a muted note is shown instead of a blank section —
 * indicating the references haven't been generated yet rather than silently
 * hiding the section.
 *
 * Data shape: string[] — each string is a formatted APA reference.
 */
import { TitledSection } from './DossierPrimitives';

export function ReferencesRenderer({ references }: { references: string[] }) {
  return (
    <TitledSection title="References (APA)">
      {references.length === 0 ? (
        <p className="text-[13px] text-muted italic m-0">
          No references generated yet. References will appear here once the TD agent run is complete.
        </p>
      ) : (
        <ol className="m-0 p-0 space-y-2 list-none">
          {references.map((ref, i) => (
            <li
              key={i}
              className="text-[13px] leading-[1.6] pl-6 -indent-6"
              style={{ paddingLeft: '1.5rem', textIndent: '-1.5rem' }}
            >
              {ref}
            </li>
          ))}
        </ol>
      )}
    </TitledSection>
  );
}
